
import { Component, Vue } from "vue-property-decorator";
import { accountApi } from "../../services/api/account/account";
import AnonymousLayout from "../../layouts/AnonymousLayout.vue";
import { ForgotPasswordOptionsCommand } from "../../services/api/models/ForgotPasswordOptionsCommand.model";

@Component({
  components: { AnonymousLayout },
})
export default class ForgotPasswordConfirmation extends Vue {
  private documentation = "";
  private isLoading = false;
  private error = false;
  private message = "";
  private notice = "";
  $router: any;
  $t: any;
  $route: any;

  get disabledForm(): boolean {
    return this.documentation === "";
  }

  async created() {
    this.notice = "";
    const forceChangePassword = this.$route.params.forceChangePassword;
    if (forceChangePassword && forceChangePassword === true) {
      this.notice = this.$t(`errors.force_change_password`);
    }
  }

  async login() {
    this.$router.push({ name: "Login" });
  }

  async submit(e: any) {
    this.isLoading = true;
    this.error = false;
    this.message = "";
    e.preventDefault();

    try {
      if (this.documentation != "") {
        var documentationType = await accountApi.forgotPasswordOptions(
          new ForgotPasswordOptionsCommand(this.documentation)
        );
        await this.$router.push({
          name: "ForgotPasswordOptions",
          params: {
            documentationType: documentationType,
            documentationId: this.documentation,
          },
        });
      } else {
        this.error = true;
        this.message = "El número de identificación es requerido.";
      }
    } catch (err) {
      this.error = true;

      if (err?.response?.status === 404 && err.response.data?.errors[0]) {
        this.message = this.$t(`errors.${err.response.data?.errors[0]}`);
      }

      if (err.response.status === 400 && err.response.data) {
        this.message = err.response.data;
      }
    }

    this.isLoading = false;
  }
}
